export const DF_BASE = 20
export const DF_STEP_SMALL = 2
export const DF_STEP_MED = 5
export const DF_STEP_LARGE = 9
